import styled from 'styled-components';
import InputMask from 'react-input-mask';

interface ButtonProps {
  disabled?: boolean;
  hasMargin: boolean;
}

interface InputProps {
  id: string;
  hasToken: boolean;
  error: boolean;
}

interface LineMask {
  sizeMargin: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  background: ${(props) => props.theme.colors.primaryDark1};

  @media screen and (max-width: 960px) {
    justify-content: initial;
  }
`;

export const Container = styled.div`
  width: 1200px;
  height: 535px;
  display: flex;
  justify-content: space-between;
  padding: 52px 0 60px 0;
  color: ${(props) => props.theme.colors.white};

  @media screen and (min-width: 961px) and (max-width: 1199px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media screen and (max-width: 960px) {
    height: auto;
    flex-direction: column;
    align-items: center;
    padding: 32px 20px;
  }
`;

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerImage = styled.div`
  display: flex;
  justify-content: center;
`;

export const Image = styled.img`
  width: 340px;
  height: 355px;
  margin-top: 56px;
  margin-right: 85px;
  margin-bottom: 56px;

  @media screen and (min-width: 961px) and (max-width: 1199px) {
    margin-right: 0;
  }

  @media screen and (max-width: 960px) {
    margin-right: 0;
    margin-top: 32px;
    width: 230px;
    height: 242px;
  }
`;

export const Title = styled.div`
  font-weight: 400;
  font-size: 28px;
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 20px;
    margin-bottom: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 620px;
  font-weight: 400;
  font-size: 26px;

  h2 {
    font-weight: 700;
    font-size: 40px;
    line-height: 120%;
    margin-bottom: 20px;
  }

  p {
    font-weight: 400;
    font-size: 22px;
    line-height: 140%;
    margin-bottom: 32px;
  }

  @media screen and (max-width: 960px) {
    max-width: none;
    h2 {
      font-size: 28px;
      margin-bottom: 16px;
    }

    p {
      font-size: 16px;
      margin-bottom: 24px;
    }
  }
`;

export const PreviewContainer = styled.div<LineMask>`
  font-weight: 700;
  font-size: 32px;
  margin-bottom: ${(props) => (props.sizeMargin ? '28px' : '32px')};
  color: ${(props) => props.theme.colors.white};

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin-bottom: ${(props) => (props.sizeMargin ? '20px' : '24px')};
  }
`;

export const Button = styled.button<ButtonProps>`
  background: ${(props) => props.theme.colors.primary};
  color: #fff;
  width: 152px;
  padding: 24px 36px 20px 36px;
  height: 72px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.4);
  margin-top: ${(props) => props.hasMargin && '22px'};

  @media screen and (max-width: 960px) {
    width: ${(props) =>
      props.hasMargin ? '100%' : 'calc(100% - 20px - 148px)'};
  }
`;

export const Input = styled(InputMask)<InputProps>`
  width: ${(props) => {
    if (props.hasToken) {
      if (props.id === 'token') {
        return '180px';
      } else {
        return '120px';
      }
    } else {
      return '120px';
    }
  }};
  height: 72px;
  background: ${(props) => props.theme.colors.white};
  font-weight: 400;
  font-size: 22px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.4);
  text-align: center;
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};

  @media screen and (max-width: 960px) {
    width: ${(props) => {
      if (props.hasToken) {
        if (props.id === 'token') {
          return '100%';
        } else {
          return '120px';
        }
      } else {
        return '148px';
      }
    }};
  }
`;

export const ContainerInteraction = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Column = styled.div<{ id: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 20px;

  @media screen and (max-width: 960px) {
    width: ${(props) => props.id === 'token' && 'calc(100% - 140px)'};
    padding-right: ${(props) => (props.id !== 'token' ? '20px' : 0)};
  }
`;

export const Label = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryLight};
  margin-bottom: 8px;
`;

export const TagError = styled.div`
  position: relative;
  z-index: 20;
  padding: 3px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  top: -10px;
  margin: 0 auto;
`;
